import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ApiService } from '../../app/services/api.service';

@Component({
  selector: 'page-commerce',
  templateUrl: 'commerce.html',
})
export class CommercePage {

  commerceHTML: SafeHtml;
  rootPage: any;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private sanitizer: DomSanitizer,
    private _apiService: ApiService
    ) {
      console.log(localStorage.getItem("commerceHTML"));
      this._apiService.getConfigs(['SPECIFIED_COMMERCIAL_TRANSACTION_HTML']).subscribe(
        (result) => {
          this.commerceHTML = this.sanitizer.bypassSecurityTrustHtml(result.result['SPECIFIED_COMMERCIAL_TRANSACTION_HTML']);
        }
      );
  }
}



// WEBPACK FOOTER //
// ./src/pages/commerce/commerce.ts